<label
    class="tw-text-[14px] tw-font-[500] tw-mb-[8px] tw-text-[#7B7575]"
    *ngIf="label !== null"
    >{{ label }}

    <span class="tw-text-red-400" *ngIf="mandatoryField === true">*</span>
</label>

<div
    class="borderCss {{
        'tw-flex tw-justify-center tw-pl-[1.2rem] tw-pr-[1rem] tw-rounded-2xl tw-py-2 tw-flex-col tw-bg-white tw-w-[100%] ' +
            (errors.length > 0 ? 'errorBorderCss ' : '') +
            (classOverrides !== null ? ' ' + classOverrides : '') +
            (isFocus == true ? 'focusedBorderCss ' : '')
    }}"
    style="min-height: 50px"
>
    <div class="tw-flex tw-items-baseline tw-justify-between">
        <div
            class="tw-flex tw-w-full"
            *ngIf="phoneNoCodeLabel !== undefined; else normalInput"
        >
            <input
                *ngIf="phoneNoCodeLabel !== undefined"
                class="tw-text-[18px] tw-text-gray-400 tw-bg-white tw-max-w-[40px] tw-font-[500]"
                value="{{ phoneNoCodeLabel }}"
                disabled
            />

            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                class="tw-w-full tw-text-[18px] tw-bg-white tw-ml-2 tw-text-black tw-font-[500] changeInputColor"
                placeholder="{{ placeHolder }}"
                (input)="onInputChange()"
                (focus)="onFocus()"
                (blur)="onBlur()"
            />
        </div>

        <ng-template #normalInput>
            <input
                [type]="hide ? 'password' : inputType"
                [formControlName]="
                    controlName !== undefined ? controlName : null
                "
                class="tw-w-full tw-text-[18px] tw-bg-white tw-text-black tw-font-[500]"
                placeholder="{{ placeHolder }}"
                (input)="onInputChange()"
                (focus)="onFocus()"
                (blur)="onBlur()"
        /></ng-template>
        <mat-icon
            *ngIf="removeValue && currentValue.length > 0"
            class="placeholder tw-mt-[-17px] tw-cursor-pointer"
            (click)="removeValueHandler()"
            >cancel</mat-icon
        >

        <img
            *ngIf="hideInput"
            class="tw-cursor-pointer"
            [ngStyle]="{
                'margin-top': label === null ? '-5px' : '-17px'
            }"
            (click)="toggleHideInput()"
            [src]="
                hide
                    ? '../../../assets/images/login-signup/Close-Eye-Vector.svg'
                    : '../../../assets/images/login-signup/Open-Eye-Vector.svg'
            "
            alt="Toggle visibility"
        />

        <mat-icon
            class="tw-cursor-pointer tw-bg-[#e5e7eb]"
            *ngIf="showCloseIcon && !hideInput"
            (mousedown)="clearInput()"
            >close</mat-icon
        >
        <button
            *ngIf="resetPasswordButton"
            (click)="resetPass()"
            class="tw-bg-[#FFBD7B] tw-text-white tw-font-semibold tw-py-3 tw-px-6 tw-rounded-full"
        >
            {{ "COMMON.CHANGE" | translate }}
        </button>
        <div class="tw-relative">
            <button
                *ngIf="resetMobileButton"
                (click)="resetMobilePhone()"
                class="tw-bg-[#FFBD7B] tw-text-white tw-font-semibold tw-py-3 tw-px-6 tw-rounded-full {{
                    verifyMobileButton ? 'tw-mr-[5px]' : ''
                }}"
                (mouseover)="resetMobileTooltip = true"
                (mouseout)="resetMobileTooltip = false"
            >
                {{ "COMMON.CHANGE" | translate }}
            </button>
            <div
                class="tw-absolute tw-bottom-[160%] -tw-right-5 md:tw-top-[180%] md:-tw-translate-y-[50%] md:tw-left-32 tw-w-[277px] md:tw-w-[277px]"
            >
                <app-tooltip
                    [showInfoTooltip]="resetMobileTooltip"
                    [tooltipData]="resetMobileTooltipData"
                ></app-tooltip>
            </div>
        </div>
        <div class="{{ verifyMobileTooltip ? 'tw-relative' : '' }}">
            <button
                *ngIf="verifyMobileButton"
                (click)="verifyMobilePhone()"
                class="tw-bg-[#FFE5CC] tw-font-semibold tw-py-3 tw-px-6 tw-rounded-full"
                (mouseover)="verifyMobileTooltip = true"
                (mouseout)="verifyMobileTooltip = false"
            >
                {{ "PROFILE.VERIFY_OTP" | translate }}
            </button>
            <div
                class="tw-absolute tw-bottom-[180%] -tw-right-5 md:tw-top-[250%] md:-tw-translate-y-[50%] md:tw-left-28 tw-w-[277px] md:tw-w-[277px]"
            >
                <app-tooltip
                    [showInfoTooltip]="verifyMobileTooltip"
                    [tooltipData]="verifyMobileTooltipData"
                ></app-tooltip>
            </div>
        </div>
    </div>
</div>

<div *ngIf="errors.length > 0" class="tw-flex tw-flex-col tw-mt-3">
    <div
        *ngFor="let error of errors; let i = index"
        class="tw-flex tw-gap-2 tw-items-center tw-text-[#7B7575] tw-text-[16px]"
    >
        <mat-icon class="error-icon !tw-overflow-visible">close</mat-icon>

        <span
            [ngClass]="{
                'tw-border-b tw-border-gray-200': i !== errors.length - 1,
                'tw-py-3': errors.length - 1 > 0,
                'tw-w-full': true
            }"
            >{{ error }}</span
        >
    </div>
</div>

<div *ngIf="strength !== null" class="tw-flex tw-mt-4 tw-gap-4">
    <div
        *ngFor="let no of strengthArray; let i = index"
        class="tw-bg-white tw-h-[4px] tw-flex-1 tw-rounded-[3rem]"
        [ngStyle]="{
            'background-color': i < strength ? strengthColor : '#dcdcdc'
        }"
    ></div>
</div>

<div
    class="tw-text-right tw-mt-2 tw-text-gray-500 tw-mb-5"
    *ngIf="strengthLabel !== null"
>
    {{ strengthLabel | translate }}
</div>
